import { Rect } from '../../../platform/geom/Rect';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Zone } from './Zone';
import { ZoneTitleFieldTextSettings } from './ZoneTitleField';

const zoneMargin = 8;

const measureInner = ({ border }: Zone, base: Rect) => {
    return new Rect(
        border[0],
        border[1],
        base.width - border[0] - border[2],
        base.height - border[1] - border[3],
    );
};

const measureHeading = (zone: Zone, inner: Rect) => {
    const { headingPosition, headingOffset, headingStyle } = zone;
    inner = inner.inflate(-10);

    const titleSettings = ZoneTitleFieldTextSettings(zone);
    const emojiSize = TextRuler.measureHeight(zone.title.slice(0, 5), titleSettings, zone.width);

    const padding = (
        (headingStyle === 'fill' ? 5 : null) ??
        (headingStyle === 'roundFill' ? 10 : null) ??
        0
    );

    const titleWidth = Math.min(inner.width - emojiSize - padding, TextRuler.measureSize(zone.title, titleSettings).w);
    const titleHeight = TextRuler.measureHeight(zone.title, titleSettings, titleWidth);

    const width = padding + emojiSize + 5 + titleWidth + padding;
    const height = Math.max(emojiSize, titleHeight);

    // headingPosition can be left, center or right

    const left = (
        (headingPosition === 'right' ? inner.right - width : null) ??
        (headingPosition === 'center' ? inner.left + (inner.width / 2) - (width / 2) : null) ??
        inner.left
    );

    const top = inner.top + headingOffset;

    const emoji = new Rect(left + padding, top, emojiSize, emojiSize);

    const heading = new Rect(left, top, width, height);
    const title = new Rect(emoji.right + 5, top, titleWidth, titleHeight);

    return { heading, emoji, title };
};

export const ZoneLayout = (zone: Zone) => {
    const { width, height } = zone;

    const base = new Rect(0, 0, width, height);
    const inner = measureInner(zone, base);
    const { heading, emoji, title } = measureHeading(zone, inner);
    const handle = new Rect(0, 0, zoneMargin + title.right + Math.max(0, 100 - title.width), zoneMargin + title.bottom);
    const content = inner.set({ top: heading.bottom + 10, height: inner.bottom - heading.bottom - 10 });

    return { base, handle, content, inner, heading, emoji, title };
};

export type ZoneLayout = ReturnType<typeof ZoneLayout>;
